import {
    http,
    Header,
    ContentType,
    qs,
    GetFormData,
    StatusCode,
    Global,
    Method
} from './api-util';
import { platformConfig } from '@/ai-api/platformApi';

/**
 * 关于我们
 */
export const aboutUs = async () => {
    const { data } = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/about-us.json`
    });

    return { info: data };
};

/**
 * app
 */
export class AppConfig {
    projectName = ''
    websiteName = ''
    domain = ''
    email = ''

    fill(appConfig) {
        this.projectName = appConfig.projectName;
        this.websiteName = appConfig.websiteName;
        this.domain = appConfig.domain;
        this.email = appConfig.email;
    }
}

export const app = async () => {
    // 平台基础信息走 src/ai-api 统一层（与 ai_mobile 同构，见 platformApi.ts；
    // 剥别名式全路径在 platformApi 内维护，业务侧不再裸拼 URL）
    const info = await platformConfig();

    return { info };
};

/**
 * home
 */
export const home = async () => {
    const { data } = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/home.json`
    });

    return { info: data };
};

/**
 * contact
 */
export const contact = async () => {
    const { data } = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/contact.json`
    });

    return data;
};

/**
 * 网站有关信息
 */
export const website = async () => {
    const { data } = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/website.json`
    });

    return { info: data };
};

export const recordUrl = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/record-url.json`
    }).then(res => res.data)
        .then(data => data.recordUrl)
}

export const recordTime = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/record-time.json`
    }).then(res => res.data)
        .then(data => data.recordTime)
}

/**
 * ai
 * @returns {*}
 */
export const aiConfig = async () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/ai.json`,
    }).then(res => res.data)
}

/**
 * nav
 * @returns {*}
 */
export const nav = async () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/nav.json`,
    }).then(res => res.data)
}